import { colors } from '~/theme/colors.js';

// Get status color for calendar events
export function getStatusColor(status) {
  const colorMap = {
    open: colors.blue,
    accepted: colors.green,
    tentative: colors.gray,
    rejected: colors.red
  };
  return colorMap[status] || 'default';
}

// Convert reservation to calendar event format
export function convertToCalendarEvent(reservation) {
  return {
    id: reservation.id,
    title: `${reservation.material?.name || ''} ${reservation.user?.name || ''} ${reservation.user_remark ? '"' + reservation.user_remark.substr(0, 35) + '"' : ''}`,
    start: reservation.date_from,
    end: reservation.date_to,
    backgroundColor: getStatusColor(reservation.status),
    borderColor: getStatusColor(reservation.status),
    extendedProps: { ...reservation }
  };
}
